import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class AppInitValues {
                                                                
    public static INITIAL_SERVICE = 'HUB';
    public static INITIAL_PRODUCT = 'HUB';
    //public static PRODUCT = 'HUB';
    public static PRODUCT = 'CITIZENPORTAL';
    public static SERVICE = 'HUB';
}
